import { createSelector } from 'reselect';
import each from 'lodash/each';
import last from 'lodash/last';
const getSpeechBlocs = (state) => state.speechBlocs.blocs;
export const blocsGroupedBySpeaker = createSelector([getSpeechBlocs], (speechBlocs) => {
    const groups = [];
    each(speechBlocs, (bloc) => {
        if (groups.length === 0 || last(groups)[0].speakerId !== bloc.speakerId) {
            return groups.push([bloc]);
        }
        return last(groups).push(bloc);
    });
    return groups;
});
const formatSearchString = (str) => str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
const getTranscripts = (state) => state.scribeConversation.transcriptsCurrent.map((tid) => state.scribeConversation.transcripts[tid]);
export const getRichTranscripts = createSelector([getTranscripts], (transcripts) => transcripts);
const getFinalTranscripts = (state) => state.scribeConversation.transcriptsFinal;
export const getRichFinalTranscripts = createSelector([getFinalTranscripts], (transcriptsFinal) => transcriptsFinal);
const getSearchQuery = (state) => state.scribeTranscriptUI.searchQuery;
const getLastEditedWordIndex = (state) => state.scribeConversation.ui.lastEditedWordIndex;
const empty = [];
// TODO: Get to the bottom of why lastEditiedWordIndex doesnt always have a parent transcript and correctly handle
export const getSearchMatches = createSelector([getRichTranscripts, getSearchQuery, getLastEditedWordIndex], (richTranscripts, query, lastEditedWordIndex) => {
    if (!query.trim())
        return empty;
    let previousWordCount = 0;
    const parentTranscriptIndex = richTranscripts.findIndex((t) => {
        const transcriptWordLength = t.text.split(' ').length;
        if (lastEditedWordIndex < transcriptWordLength + previousWordCount)
            return true;
        previousWordCount += transcriptWordLength;
        return false;
    });
    const parentTranscript = richTranscripts[parentTranscriptIndex];
    const startingWordIndex = previousWordCount;
    let transcriptsToSearchThrough;
    let wordIndexInTranscript;
    if (!parentTranscript) {
        wordIndexInTranscript = 0;
        transcriptsToSearchThrough = richTranscripts;
    }
    else {
        wordIndexInTranscript = lastEditedWordIndex - startingWordIndex;
        const firstTranscriptToSearchIndex = richTranscripts.findIndex((t) => t.id === parentTranscript.id);
        transcriptsToSearchThrough = richTranscripts.slice(firstTranscriptToSearchIndex);
    }
    return transcriptsToSearchThrough.reduce((matches, t) => {
        let wordIndexToSearchFrom;
        if (!parentTranscript) {
            wordIndexToSearchFrom = 0;
        }
        else {
            wordIndexToSearchFrom = parentTranscript.id === t.id ? wordIndexInTranscript + 1 : 0;
        }
        const newMatches = t.text
            .split(' ')
            .map((word, index) => ({ word, index, transcriptId: t.id }))
            .slice(wordIndexToSearchFrom)
            .filter(({ word }) => formatSearchString(word).indexOf(formatSearchString(query)) > -1);
        return [...matches, ...newMatches];
    }, []);
});
export const getPaidASRCreditTime = (state) => state.firebase.paidASRCreditTime;
export const getScribeRemainingTime = (state) => state.firebase.scribeRemainingTime;
export const getRecording = (state) => state.scribeConversation.recording;
export const getStatus = (state) => state.scribeConversation.status;
export const getSubscription = (state) => state.scribeSession.subscription;
export const getSelectedCaptions = (state) => state.scribeSession.selectedCaptions;
export const getLang = (state) => state.scribeConversation.lang;
export const getLangs = (state) => state.scribeConversation.langs;
